export default function onSelectionChange(
  selection,
  aceEditor,
  player,
  socket
) {
  // ! The if statement only works when in order and should not be changed

  // get the selected text
  const content = aceEditor.current.editor.session.getTextRange(
    selection.getRange()
  );

  console.log('content', content);

  // check if the selected text is a command
  if (content.length < 4) {
    // console.log('Returning in selecions');
    return;
  }

  // extract the search command
  if (content.includes('search')) {
    try {
      /* This is extracting the search command. */
      const index = content.indexOf(')');
      const searchParam = content.substring(7, index);
      /* Sending a command to the server. */
      socket.emit('sendCommand', {
        command: 'search',
        param: searchParam,
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the play command
  if (content.includes('play') && content.length >= 6) {
    try {
      const index = content.indexOf(')');
      const playerNum = content.substring(5, index);
      socket.emit('playerCommand', {
        command: 'play',
        param: { playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the pause command
  if (content.includes('pause') && content.length >= 7) {
    try {
      const index = content.indexOf(')');
      const playerNum = content.substring(6, index);
      socket.emit('playerCommand', {
        command: 'pause',
        param: { playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the stop command
  if (content.includes('stop') && content.length >= 6) {
    try {
      const index = content.indexOf(')');
      const playerNum = content.substring(5, index);
      socket.emit('playerCommand', {
        command: 'stop',
        param: { playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the clear command
  if (content.includes('clear') && content.length >= 7) {
    try {
      const index = content.indexOf(')');
      const playerNum = content.substring(6, index);
      socket.emit('playerCommand', {
        command: 'stop',
        param: { playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the mute command
  if (content.includes('mute') && content.length >= 7) {
    try {
      const index = content.indexOf(')');
      const playerNum = content.substring(5, index);
      socket.emit('playerCommand', {
        command: 'mute',
        param: { playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the unmute command
  if (content.includes('unmute') && content.length >= 7) {
    try {
      const index = content.indexOf(')');
      const playerNum = content.substring(7, index);
      socket.emit('playerCommand', {
        command: 'unmute',
        param: { playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the seek command
  if (content.includes('seek') && content.length >= 9) {
    try {
      const startIndex = content.indexOf('(');
      const elPlayerNum = content.split(',')[0].trim();
      const playerNum = elPlayerNum.substring(startIndex + 1);

      const el = content.split(',')[1].trim();
      const endIndex = el.indexOf(')');
      const seconds = el.substring(0, endIndex);

      socket.emit('playerCommand', {
        command: 'seek',
        param: { param: seconds, playerNum: playerNum },
      });
      // console.log(seconds);
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the loopAt command
  if (content.includes('loopAt') && content.length >= 13) {
    try {
      const startIndex = content.indexOf('(');
      const elPlayerNum = content.split(',')[0].trim();
      const playerNum = elPlayerNum.substring(startIndex + 1);

      const startLoop = content.split(',')[1].trim();

      const el = content.split(',')[2].trim();
      const endIndex = el.indexOf(')');
      const endLoop = el.substring(0, endIndex);

      // console.log('end command', endLoop);
      // console.log('start command', startLoop);
      // console.log('playerNum', playerNum);

      socket.emit('playerCommand', {
        command: 'loopAt',
        param: { param: { startLoop, endLoop }, playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  if (content.includes('select') && content.length >= 9) {
    try {
      const index = content.indexOf(')');
      const playerNum = content.substring(7, index);
      // console.log(playerNum);
      socket.emit('playerCommand', {
        command: 'select',
        param: { playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the delay command
  if (content.includes('delay') && content.length >= 10) {
    try {
      const startIndex = content.indexOf('(');
      const elPlayerNum = content.split(',')[0].trim();
      const playerNum = elPlayerNum.substring(startIndex + 1);

      const el = content.split(',')[1].trim();
      const endIndex = el.indexOf(')');
      const rate = el.substring(0, endIndex);

      // console.log(rate);
      socket.emit('playerCommand', {
        command: 'delay',
        param: { param: rate, playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }

  // extract the fade command
  if (content.includes('fade') && content.length >= 9) {
    try {
      const startIndex = content.indexOf('(');
      const elPlayerNum = content.split(',')[0].trim();
      const playerNum = elPlayerNum.substring(startIndex + 1);

      const el = content.split(',')[1].trim();
      const endIndex = el.indexOf(')');
      const level = el.substring(0, endIndex);

      // console.log(level);
      // level is in percentage
      socket.emit('playerCommand', {
        command: 'fade',
        param: { param: level, playerNum: playerNum },
      });
      return;
    } catch (e) {
      console.log(e);
    }
  }
}
